import React from "react";
import "./App.css";

import Weather from "./Weather";
function App() {
  return (
    <div className="App">
      <div className="conteiner">
        <Weather defaultCity="Kyiv" />
        <footer>
          <p>
            This project was coded by{" "}
            <a
              href="https://www.facebook.com/inna.roeva"
              target="_blank"
              rel="nooprner noreferrer"
            >
              Inna Nedohybchenko{" "}
            </a>{" "}
            and is{" "}
            <a
              href="https://github.com/in4ik1303/react-inna2"
              target="_blank"
              rel="nooprner noreferrer"
            >
              open-sourke code on GitHub
            </a>{" "}
            hosted on{" "}
            <a
              href="https://adorable-parfait-f79ee5.netlify.app/"
              target="_blank"
              rel="nooprner noreferrer"
            >
              Netlify
            </a>
          </p>
        </footer>
      </div>
    </div>
  );
}

export default App;
